// import { CalendarIcon } from "../../shared/Icons";
import { ReactComponent as CalendarIcon } from "../../shared/assets/calendar.svg";

export interface CustomDatePickerInputProps {
  value: string;
  onClick: React.MouseEventHandler<HTMLDivElement>;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const CustomDatePickerInput: React.FC<CustomDatePickerInputProps> = ({ value, onClick, onChange }) => (
  <div className="date-picker-input flex cursor-pointer items-center rounded border p-2">
    <input
      type="text"
      value={value}
      onChange={onChange}
      className="flex-1 border-none outline-none focus:outline-none"
      placeholder="MM/DD/YYYY"
      style={{ minWidth: "100px" }}
    />
    <div className="flex items-center" onClick={onClick}>
      <CalendarIcon className="h-6 w-6 text-green" />
    </div>
  </div>
);
